import uniq from 'lodash/uniq';
import flatten from 'lodash/flatten';
import values from 'lodash/values';
import difference from 'lodash/difference';
import isEqual from 'lodash/isEqual';

// Actions
const FETCH_DOMAINS = 'zen/tierOverride/FETCH_DOMAINS';
const FETCH_DOMAINS_SUCCEEDED = 'zen/tierOverride/FETCH_DOMAINS_SUCCEEDED';
const FETCH_DOMAINS_FAILED = 'zen/tierOverride/FETCH_DOMAINS_FAILED';
const UPDATE_DOMAINS = 'zen/tierOverride/UPDATE_DOMAINS';
const UPDATE_DOMAINS_SUCCEEDED = 'zen/tierOverride/UPDATE_DOMAINS_SUCCEEDED';
const UPDATE_DOMAINS_FAILED = 'zen/tierOverride/UPDATE_DOMAINS_FAILED';
const LOAD_PROPS = 'zen/tierOverride/LOAD_PROPS';
const HANDLE_DOMAIN_CHANGE = 'zen/tierOverride/HANDLE_DOMAIN_CHANGE';
const CONFIRM_CANCEL = 'zen/tierOverride/CONFIRM_CANCEL';
const OPEN_CONFIRM_MODAL = 'zen/tierOverride/OPEN_CONFIRM_MODAL';
const HIDE_CONFIRM_MODAL = 'zen/tierOverride/HIDE_CONFIRM_MODAL';
const RESET_SUCCESS_MESSAGE = 'zen/tierOverride/RESET_SUCCESS_MESSAGE';

export const initialState = {
  accountId: null,
  loading: false,
  oldTiers: {
    tier1: [],
    tier2: [],
    tier3: []
  },
  tiers: {
    tier1: [],
    tier2: [],
    tier3: []
  },
  errors: {},
  isConfirmModalOpen: false,
  isUnsaved: false,
  saveSucceeded: false,
  redirectTarget: null
};

// Reducer
// eslint-disable-next-line complexity
const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case LOAD_PROPS:
      return {...state, accountId: action.payload.accountId};
    case FETCH_DOMAINS:
      return {...state, loading: true};
    case FETCH_DOMAINS_SUCCEEDED: {
      const { tiers } = action.payload;
      // set oldTiers as the state to fall back to if user cancels
      return { ...state, loading: false, tiers, oldTiers: tiers };
    }
    case FETCH_DOMAINS_FAILED:
      // TODO handle error state
      return { ...state, loading: false };
    case UPDATE_DOMAINS_SUCCEEDED:
      return { ...state, isUnsaved: false, saveSucceeded: true, oldTiers: state.tiers, errors: {} };
    case UPDATE_DOMAINS_FAILED: {
      const tier3 = 'There was an error updating domains';
      return { ...initialState, accountId: state.accountId, loading: true, errors: { tier3 } };
    }
    case HANDLE_DOMAIN_CHANGE: {
      const { domains, key } = action.payload;
      const tiers = Object.assign({}, state.tiers);
      delete tiers[key];
      const allOtherDomains = flatten(values(tiers));
      const tierDomains = domains || [];
      // filter any duplicates from all tiers and anything that fails domain regex test
      const uniqTierDomains = difference(uniq(tierDomains), allOtherDomains);
      const filteredTierDomains = uniqTierDomains.filter((domain) => {
        const patt = /^(?!:\/\/)([a-zA-Z0-9-]+\.)*?[a-zA-Z0-9][a-zA-Z0-9-]+\.[a-zA-Z]{2,6}?$/g;
        return patt.test(domain);
      });
      tiers[key] = filteredTierDomains;
      // TODO - errors are not being used right now, but if they are later, this needs to have
      // different messaging for duplicate error and regex test error
      const duplicateError = (filteredTierDomains.length !== tierDomains.length)
        && 'Duplicate domains have been removed.';
      // don't bother with cancel/update if nothing has changed
      const isUnsaved = !isEqual(tiers, state.oldTiers);
      return { ...state, isUnsaved, tiers, errors: { [key]: duplicateError } };
    }
    case OPEN_CONFIRM_MODAL: {
      const redirectTarget = action.payload.redirectTarget;
      return { ...state, isConfirmModalOpen: true, redirectTarget };
    }
    case HIDE_CONFIRM_MODAL:
      return { ...state, isConfirmModalOpen: false };
    case CONFIRM_CANCEL:
      return {
        ...state, isUnsaved: false, isConfirmModalOpen: false,
        tiers: state.oldTiers, errors: {}
      };
    case RESET_SUCCESS_MESSAGE:
      return {
        ...state, saveSucceeded: false,
      };
    default: return state;
  }
};

// Action Creators

// FETCH
const fetchDomains = () => {
  return { type: FETCH_DOMAINS };
};
const fetchDomainsSucceeded = (payload) => {
  return { type: FETCH_DOMAINS_SUCCEEDED, payload };
};
const fetchDomainsFailed = () => {
  return { type: FETCH_DOMAINS_FAILED };
};

// UPDATE
const updateDomains = () => {
  return { type: UPDATE_DOMAINS };
};
const updateDomainsSucceeded = () => {
  return { type: UPDATE_DOMAINS_SUCCEEDED };
};
const updateDomainsFailed = () => {
  return { type: UPDATE_DOMAINS_FAILED };
};


const loadProps = (payload) => {
  return { type: LOAD_PROPS, payload };
};

const handleDomainChange = (payload) => {
  return { type: HANDLE_DOMAIN_CHANGE, payload };
};

const openConfirmModal = (payload={}) => {
  return { type: OPEN_CONFIRM_MODAL, payload };
};

const hideConfirmModal = () => {
  return { type: HIDE_CONFIRM_MODAL };
};

const confirmCancel = () => {
  return { type: CONFIRM_CANCEL };
};

const resetSuccessMessage = () => {
  return { type: RESET_SUCCESS_MESSAGE };
};

export default reducer;
export {
  // Actions
  FETCH_DOMAINS,
  FETCH_DOMAINS_SUCCEEDED,
  FETCH_DOMAINS_FAILED,
  UPDATE_DOMAINS,
  UPDATE_DOMAINS_SUCCEEDED,
  UPDATE_DOMAINS_FAILED,
  LOAD_PROPS,
  HANDLE_DOMAIN_CHANGE,
  CONFIRM_CANCEL,
  OPEN_CONFIRM_MODAL,
  HIDE_CONFIRM_MODAL,
  RESET_SUCCESS_MESSAGE,
  // Action Creators
  fetchDomains,
  fetchDomainsSucceeded,
  fetchDomainsFailed,
  updateDomains,
  updateDomainsSucceeded,
  updateDomainsFailed,
  loadProps,
  handleDomainChange,
  openConfirmModal,
  hideConfirmModal,
  confirmCancel,
  resetSuccessMessage
};
